// Do NOT add "use client" to this file
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDefaultImageUrl, getNormalizedImageUrls } from "@faire/retailer-visitor-shared/components/Image/ProgressiveProductImage";
import { ImageOverlay } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ImageOverlay";
import { VERTICAL_ASPECT_RATIO } from "@faire/retailer-visitor-shared/lib/verticalAspectRatio";
import * as React from "react";
import { preload } from "react-dom";
export var ProductImageWithSrcsetSizes = function(param) {
    var image = param.image, alt = param.alt, sizes = param.sizes, showVerticalImagery = param.showVerticalImagery, extraProductsCount = param.extraProductsCount, smallCount = param.smallCount, loading = param.loading, onLoad = param.onLoad, _param_addOverlay = param.addOverlay, addOverlay = _param_addOverlay === void 0 ? true : _param_addOverlay, objectFit = param.objectFit;
    var dataTestId = "product-image".concat(showVerticalImagery ? "-vertical" : "");
    var normalizedUrls = getNormalizedImageUrls(image, showVerticalImagery, {});
    var src = getDefaultImageUrl(image, showVerticalImagery, {});
    preload(src, {
        as: "image"
    });
    var aspectRatio = showVerticalImagery ? VERTICAL_ASPECT_RATIO : 1;
    return /*#__PURE__*/ _jsxs("picture", {
        className: "relative flex h-0 w-full flex-shrink-0",
        style: {
            paddingTop: "calc(100% / ".concat(aspectRatio, ")")
        },
        "data-test-id": dataTestId,
        children: [
            /*#__PURE__*/ _jsx("source", {
                srcSet: normalizedUrls,
                sizes: sizes
            }),
            /*#__PURE__*/ _jsx("img", {
                className: "absolute left-0 top-0 h-full w-full object-center object-".concat(objectFit ? objectFit : "cover"),
                src: src,
                alt: alt,
                loading: loading,
                "data-product-image": "full",
                onLoad: onLoad
            }),
            addOverlay ? /*#__PURE__*/ _jsx(ImageOverlay, {
                extraProductsCount: extraProductsCount,
                smallCount: smallCount
            }) : null
        ]
    });
};
